import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const ReverseJobOrder = {
	name: NAME,
	apiProvider,
	router,
};
